import React from 'react';
import { DragOutlined } from '@ant-design/icons';
import { Icon as LegacyIcon } from '@ant-design/compatible';
import { useDrag } from 'react-dnd';
const style = {
    backgroundColor: 'white',
    padding: '0.5rem 1rem',
    cursor: 'move',
    height: 'auto',
    border: '1px #000 dashed',
};
export const PartItem = ({ index, file, type, isDropped, handleRemove }) => {
    const [collected, drag] = useDrag(() => ({
        type,
        item: { index, file, type },
    }));
    return (React.createElement("div", { className: 'draggable-item', ref: drag, style: { ...style } }, isDropped ? (React.createElement("span", null)) : (React.createElement("div", { className: "flex w-full min-w-0 items-start gap-2" },
        React.createElement(DragOutlined, { className: "shrink-0 mt-0.5" }),
        React.createElement("div", { className: "flex-1 min-w-0 break-all text-xs sm:text-sm leading-snug" }, file?.name),
        React.createElement(LegacyIcon, { title: 'Remove file', className: "shrink-0 cursor-pointer text-red-600 mt-0.5", style: { color: '#c00' }, onClick: handleRemove, type: 'delete' })))));
};
